import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useApi from '../../api/useApi';
import Moment from 'react-moment';
import useQueryParams from '../../context/useQueryParams';

const AuctioneerDashboard = () => {
    const navigate = useNavigate();
    const [auction, setAuction] = useState({});
    const { setParameters } = useQueryParams();
    const api = useApi();

    const loadAuctioneerDashboard = async () => {
        await api.getAuctioneerDashboard().then((data) => {
            if (data?.auctionStatus >= 0) {
                setAuction(data);
                setParameters(prev => ({ ...prev, auctionEndTime: data.endTime }));
            }
            else {
                navigate(`/poolingDetail/${data.auctionId}`);
            }
        })
    }

    useEffect(() => {
        loadAuctioneerDashboard();
    }, []);


    const handleAuctionDetail = () => {
        if (auction?.auctionStatus > - 1)
            navigate(`/auctioneerLots/${auction.auctionId}`);
        else
            alert("Action not allowed. No auction.")
    }

    const handleLotOverview = () => {
        if (auction?.auctionStatus > - 1)
            navigate(`/lotOverview/${auction.auctionId}`);
        else
            alert("Action not allowed. No auction.")
    }

    const handlePreviousAuctions = () => {
        navigate(`/previousAuctionsReport`);
    }
    const handlePoolingAuctions = () => {
        navigate(`/poolingDetail/0`);
    }
    const handleParticipants = () => {
        navigate(`/participants`);
    }
    const handleOTPSettings = () => {
        navigate(`/otpSettings`);
    }
    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Auctions</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a className="custom-link" >Home</a></li>
                        </ol>
                    </div>

                </div>
                <div className="row row-sm">
                    <div className="col-xl-6">
                        <div className="card custom-card bd-b-primary">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="d-flex">
                                            <div className="settings-main-icon me-4 mt-1">
                                                <div className="avatar avatar-md bg-primary-transparent text-primary"><i className="ti-home fs-18"></i></div>
                                            </div>
                                            <div>
                                                <h5 className="tx-14 d-flex tx-uppercase custom-link" onClick={handleAuctionDetail}> Auction Details</h5>
                                                {auction?.auctionStatus > -1 ?
                                                    <p className="tx-13 text-muted mb-0"> <strong> {auction?.companyName}</strong>  <br></br> <span className="badge   bg-warning  me-1">{auction?.message} </span> |  <Moment format="DD-MMM-YYYY">{auction?.auctionDate}</Moment>{" "}  {auction?.startTime ? <span><Moment format="LT">{auction?.startTime}</Moment>{"  to  "}<Moment format="LT">{auction?.endTime}</Moment></span> : null} </p>
                                                    : <p className="tx-13 text-muted mb-0"> <span className="badge   bg-warning  me-1">{auction?.message} </span> <br></br> <i><small> Please contact your administrator.</small></i>  </p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="card custom-card bd-b-primary" >
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="d-flex">
                                            <div className="settings-main-icon me-4 mt-1">
                                                <div className="avatar avatar-md bg-primary-transparent text-primary"><i className="ti-layout-grid2 fs-18"></i></div>
                                            </div>
                                            <div>
                                                <h5 className="tx-14 d-flex tx-uppercase custom-link" onClick={handlePreviousAuctions}>Auction History</h5>
                                                <p className="tx-13 text-muted mb-0">Details of previous auctions with lot detail report, CSR report and trader placed bids.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className={auction?.auctionStatus > -1 ? "card custom-card bd-b-primary" : "card custom-card bd-b-primary custom-card-disabled"}>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="d-flex">
                                            <div className="settings-main-icon me-4 mt-1">
                                                <div className="avatar avatar-md bg-primary-transparent text-primary"><i className="ti-pencil fs-18"></i></div>
                                            </div>
                                            <div>
                                                <h5 className="tx-14 d-flex tx-uppercase custom-link" onClick={handleLotOverview}>Lot Overview</h5>
                                                <p className="tx-13 text-muted mb-0">View detail of skipped / special lots of the current running auction</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className={auction?.auctionStatus > -1 ? "card custom-card bd-b-primary" : "card custom-card bd-b-primary custom-card-disabled"}>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="d-flex">
                                            <div className="settings-main-icon me-4 mt-1">
                                                <div className="avatar avatar-md bg-primary-transparent text-primary"><i className="ti-flag-alt-2 fs-18"></i></div>
                                            </div>
                                            <div>
                                                <h5 className="tx-14 d-flex tx-uppercase custom-link" onClick={handleParticipants}>Participants</h5>
                                                <p className="tx-13 text-muted mb-0">Control access of participants in current auction.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="card custom-card bd-b-primary" >
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="d-flex">
                                            <div className="settings-main-icon me-4 mt-1">
                                                <div className="avatar avatar-md bg-primary-transparent text-primary"><i className="ti-layout-grid2 fs-18"></i></div>
                                            </div>
                                            <div>
                                                <h5 className="tx-14 d-flex tx-uppercase custom-link" onClick={handlePoolingAuctions}>Cardamom Pooling</h5>
                                                <p className="tx-13 text-muted mb-0">Details of current open cardamom poolings</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="card custom-card bd-b-primary">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="d-flex">
                                            <div className="settings-main-icon me-4 mt-1">
                                                <div className="avatar avatar-md bg-primary-transparent text-primary"><i className="ti-flag-alt-2 fs-18"></i></div>
                                            </div>
                                            <div>
                                                <h5 className="tx-14 d-flex tx-uppercase custom-link" onClick={handleOTPSettings}>OTP Settings</h5>
                                                <p className="tx-13 text-muted mb-0">Control OTP based login for current auction.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuctioneerDashboard;



